import { getControlPlaneHost } from './config'
import { clearControlPlaneCsrfToken, deleteSession } from './client'
import { clearL3Token } from './tokenStore'

/**
 * Build the CP host login-redirect URL (Account Control Plane P5). On the CP
 * path, login is a full-page redirect to the CP host's OAuth seam
 * (`GET /oauth/google/start`), which owns state + PKCE + nonce and, on a known
 * subject, Set-Cookies the refresh cookie and 302s back to `returnTo`.
 */
export function buildControlPlaneLoginUrl(returnTo: string): string {
  const url = new URL(`${getControlPlaneHost()}/oauth/google/start`)
  url.searchParams.set('client', 'web')
  url.searchParams.set('purpose', 'login')
  url.searchParams.set('return_to', returnTo)
  return url.toString()
}

/** Revoke the CP session and drop all local CP state (console logout). */
export async function controlPlaneLogout(): Promise<void> {
  await deleteSession()
  clearL3Token()
  clearControlPlaneCsrfToken()
}
